// /* --- Application --- */
import './css/global.css'
import './css/anim.css'
import './css/accordion.css'
import './css/map.css'

import OiAccordion from '@components/oi-accordion/OiAccordion'
import TagManager from '@components/tag-manager/tagManager'
import 'keen-slider/keen-slider.min.css';
import FlipCard from "@components/flip-card/flipCard";
import Slider from '@components/slider/slider'

customElements.define('tag-manager', TagManager)
customElements.define('flip-card', FlipCard)

const slider = document.querySelector('.keen-slider');
if (slider){
    new Slider(slider as HTMLElement);
}

const scrollToTop = document.querySelector('#back-to-top');
if (scrollToTop) {
    scrollToTop.addEventListener("click", () => window.scrollTo(0,0))
}

const oiAccordions = document.querySelectorAll('.js-oi-accordion');
oiAccordions.forEach((element) => {
    new OiAccordion(element as HTMLElement);
});

const sectionAnchors = document.querySelectorAll('.scrollspy-section');
const menuLinks = document.querySelectorAll('.menu-link');
let blockWatching = false;

menuLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
        blockWatching = true
        const tmtOutDelay  = window.innerWidth < 768 ? 1000 : 2000;
        setTimeout(() => {
            blockWatching = false
            requestAnimationFrame(updateActiveState);
        }, tmtOutDelay);

        setTimeout(() => {

            link.classList.add('active');
        }, 100);
    });
});

function updateActiveState() {

    if(!blockWatching) {
        sectionAnchors.forEach((element, index) => {
            const rect = element.getBoundingClientRect();
            if (rect.top < 80 || (index === 0 && rect.top < window.innerHeight - 10)) {
                if ((element as HTMLElement).dataset.anchor) {
                    element.classList.add('active');
                    menuLinks.forEach((link) => {
                        if (link.getAttribute('href') === '#' + (element as HTMLElement).dataset.anchor) {
                            link.classList.add('active');
                        } else {
                            link.classList.remove('active');
                        }
                    })
                }
            } else {
                element.classList.remove('active');
            }
        });
        requestAnimationFrame(updateActiveState);
    }
}

// Animation Frame Loop starten
setTimeout(() => {
    requestAnimationFrame(updateActiveState);
},100)

 // Open main navigation if you click on the hamburger
const toggleMenu = document.querySelector('#toggle-menu')
if (toggleMenu != null) {
    toggleMenu.addEventListener('click', () => {
        toggleMenu.classList.toggle('is-open')
        document.querySelector('#main-navigation').classList.toggle('is-open')
    })
}

const intersectionObserver = ('IntersectionObserver' in window) ?
    new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add('js-animate');
                entry.target.classList.remove('js-animate-observed');

                if (intersectionObserver) {
                    intersectionObserver.unobserve(entry.target);
                }
            }
        });
    }) : null;

function bindAnimate(el, transition) {
    const animation = transition || 'fadein';
    el.classList.add('js-' + animation);
    el.classList.add('js-animate-observed');

    setTimeout(() => {
        const { top } = el.getBoundingClientRect();

        if (intersectionObserver) {
            if (top !== 0 && top < window.innerHeight) {
                el.classList.remove('js-animate-observed');

                if (window.innerWidth < 768) {
                    el.classList.add('js-no-animate');
                } else {
                    el.classList.add('js-animate-instantly');
                }
            } else {
                el.classList.add('js-animate-observed');
                intersectionObserver.observe(el);
            }
        }
    }, 0);
}

document.addEventListener("DOMContentLoaded", () => {
    const animatedElements = document.querySelectorAll('[data-animate]');

    animatedElements.forEach(el => {
        const transitionType = (el as HTMLElement).dataset.animate;
        bindAnimate(el, transitionType);
    });
});


let snapped = null;
// Debounce to detect scroll end
let isScrolling;

const snapIt = (section?: Element, smooth = false) => {
    const top = section.getBoundingClientRect().top + window.scrollY;

    if (smooth) {
        window.scrollTo(0, top);
    } else {
        window.scrollTo({
            top,
            behavior: "smooth",
        });
    }
}

const checkSnapping = () => {
    const sections = document.querySelectorAll(".snap-start");
    const threshold = 150; // px from top of viewport

    sections.forEach((section) => {
        (section as HTMLElement).style.maxHeight = window.innerHeight + "px";
        const rect = section.getBoundingClientRect();
        const distanceFromTop = rect.top;

        // If section top is within ±100px of the viewport top
        if (Math.abs(distanceFromTop) <= threshold) {
            snapped = section;

            snapIt(section, false);
        } else {
            snapped = null;
        }
    });
}

window.addEventListener("scroll", () => {
    window.clearTimeout(isScrolling);

    // Wait 150ms after scroll stops
    isScrolling = setTimeout(() => {
        checkSnapping();
    }, 150);
});

// Debounce to detect scroll end
let isResizing;

window.addEventListener("resize", () => {
    if (snapped) {
        snapIt(snapped, true);
    }

    window.clearTimeout(isResizing);

    // Wait 150ms after scroll stops
    isResizing = setTimeout(() => {
        checkSnapping();
    }, 150);
});

document.addEventListener("DOMContentLoaded", () => {
    const pageLogo = document.querySelector('#page-logo');
    const homeSection = document.querySelector('#home-section');
    const homeSectionFirstChildNode = homeSection?.firstElementChild;
    const menuLinks = document.querySelector('#menu-links');

    const resizeHomeSection = () => {
        const newH = Math.max((window.innerHeight - (pageLogo as HTMLElement).offsetHeight - (menuLinks as HTMLElement).offsetHeight), (homeSectionFirstChildNode as HTMLElement).offsetHeight) + "px";
        (homeSection as HTMLElement).style.height = newH
    }

    resizeHomeSection();

    window.addEventListener('resize', () => {
        resizeHomeSection();
    });
})